import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Redux States
import { BD_GET_SUPPLIERNAME_LISTING } from "./actionTypes"
import { bdSupplierNameListingSuccess, bdSupplierNameListingFail } from "./actions"

//Include Both Helper File with needed methods
import { bdSupplierNameListingApi } from "../../../helpers/fakebackend_helper"

function* getBdSupplierNameListing() {
  try {
    const response = yield call(bdSupplierNameListingApi)
    if (!response.results.supplier_names) {
      yield put(bdSupplierNameListingFail(error))
    }
    yield put(bdSupplierNameListingSuccess(response.results.supplier_names))
  } catch (error) {
    yield put(bdSupplierNameListingFail(error))
  }
}

function* bdSupplierNameSaga() {
  yield takeEvery(BD_GET_SUPPLIERNAME_LISTING, getBdSupplierNameListing)
}
export default bdSupplierNameSaga
